class ChatWebSocketService {
  constructor() {
    this.ws = null;
    this.callbacks = {};
    this.status = "disconnected"; // "disconnected" | "connecting" | "connected" | "error"
    this.lastSentTime = null;
  }

  getWebSocketUrl() {
    let baseUrl = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
    let wsUrl = baseUrl.replace(/^http:/, "ws:").replace(/^https:/, "wss:");
    // Ensure no trailing slash before appending /test
    wsUrl = wsUrl.replace(/\/+$/, "");
    return `${wsUrl}/test`;
  }

  connect(agentId, callbacks = {}) {
    this.disconnect();

    this.callbacks = callbacks;
    this.setStatus("connecting");

    const url = this.getWebSocketUrl();
    try {
      this.ws = new WebSocket(url);

      this.ws.onopen = () => {
        this.setStatus("connected");
        // Send initial metadata payload as required by @router.websocket("/test")
        const initPayload = {
          type: "init",
          agent_id: agentId
        };
        this.ws.send(JSON.stringify(initPayload));
        if (this.callbacks.onOpen) this.callbacks.onOpen();
      };

      this.ws.onmessage = (event) => {
        const receivedTime = Date.now();
        let latency = 0;
        if (this.lastSentTime) {
          latency = receivedTime - this.lastSentTime;
          this.lastSentTime = null;
        }

        let parsedData = event.data;
        let responseText = event.data;

        try {
          const json = JSON.parse(event.data);
          parsedData = json;
          responseText = json.text || json.message || json.response || json.content || event.data;
        } catch (_) {
          // If response is plain text, keep event.data as responseText
        }

        if (this.callbacks.onMessage) {
          this.callbacks.onMessage({
            text: String(responseText),
            latency,
            raw: parsedData
          });
        }
      };

      this.ws.onerror = (error) => {
        console.error("Chat WebSocket Error:", error);
        this.setStatus("error");
        if (this.callbacks.onError) this.callbacks.onError(error);
      };

      this.ws.onclose = (event) => {
        this.setStatus("disconnected");
        if (this.callbacks.onClose) this.callbacks.onClose(event);
      };
    } catch (err) {
      console.error("Failed to initialize WebSocket:", err);
      this.setStatus("error");
      if (this.callbacks.onError) this.callbacks.onError(err);
    }
  }

  sendMessage(text, agentId) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      console.warn("WebSocket is not connected. Message not sent.");
      return false;
    }

    this.lastSentTime = Date.now();
    const payload = {
      type: "message",
      text,
      agent_id: agentId
    };

    this.ws.send(JSON.stringify(payload));
    return true;
  }

  setStatus(status) {
    this.status = status;
    if (this.callbacks.onStatusChange) {
      this.callbacks.onStatusChange(status);
    }
  }

  disconnect() {
    if (this.ws) {
      try {
        this.ws.onopen = null;
        this.ws.onmessage = null;
        this.ws.onerror = null;
        this.ws.onclose = null;
        if (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING) {
          this.ws.close();
        }
      } catch (err) {
        console.warn("Error closing WebSocket:", err);
      }
      this.ws = null;
    }
    this.setStatus("disconnected");
  }
}

export const chatWebSocket = new ChatWebSocketService();
export default ChatWebSocketService;
